// PANTALLA 0.2 — La Transición (permiso para conocerte)
// Copy: ../lobbyContent.js → LOBBY_HANDOFF
//
// Última pantalla antes del diagnóstico. Explicita qué viene, cuánto dura y
// que no hay registro de por medio: el usuario entra a la Pantalla 1 sabiendo
// en qué se está metiendo, en vez de ser emboscado con una pregunta personal.
import { LOBBY_HANDOFF } from '../lobbyContent';

export default function LobbyHandoff({ onNext, onBack }) {
  return (
    <div className="ob-screen">
      <button type="button" className="ob-back" onClick={onBack}>
        ← Volver
      </button>

      <p className="ob-eyebrow">{LOBBY_HANDOFF.eyebrow}</p>
      <h1 className="ob-headline">
        {LOBBY_HANDOFF.headline}{' '}
        <span className="ob-bloque">{LOBBY_HANDOFF.headlineBloque}</span>
      </h1>
      <p className="ob-body">{LOBBY_HANDOFF.subheadline}</p>

      <ul className="ob-promises">
        {LOBBY_HANDOFF.promises.map((p, i) => (
          <li
            key={p.text}
            className="ob-promise"
            style={{ animationDelay: `${0.1 + i * 0.09}s` }}
          >
            <span className="ob-promise-icon" aria-hidden="true">{p.icon}</span>
            <span>{p.text}</span>
          </li>
        ))}
      </ul>

      <div className="ob-actions">
        <button type="button" className="ob-btn ob-btn-lg" onClick={onNext}>
          {LOBBY_HANDOFF.cta}
        </button>
      </div>
    </div>
  );
}
